import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PerModelStat {
  model: string;
  mpp?: number;
  count?: number;
  sentiment_score?: number;
}

export interface SentimentCount {
  word: string;
  count: number;
}

export interface SOVPieData {
  label: string;
  value: number;
  color: string;
}

export interface CompetitorData {
  name: string;
  count: number;
  sovPct: number;
  sentiments: string[];
  sentiment_score?: number;
}

export interface PersonaMetrics {
  name: string;
  role?: string;
  industry?: string;
  environment_scale?: string;
  location?: string;
  questionCount?: number;
  avgRank?: number;
  mentionsPerPrompt?: number;
  totalMentions?: number;
  sovPct?: number;
}

export interface CalculatedMetrics {
  domainId: string;
  brandName: string;
  avgRank?: number;
  mentionsPerPrompt?: number;
  totalMentions?: number;
  totalMentionsAllCompanies?: number; // Sum of all companies' mentions for SOV percentage calculation
  analyzedPrompts?: number;
  analyzedAnswers?: number;
  perModelStats: PerModelStat[];
  sentimentCounts: SentimentCount[];
  sovPieData: SOVPieData[];
  competitors: CompetitorData[];
  personas: PersonaMetrics[];
  calculatedAt: number; // timestamp
}

interface MetricsState {
  metricsByDomain: Record<string, CalculatedMetrics>;
}

const initialState: MetricsState = {
  metricsByDomain: {},
};

const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {
    setCalculatedMetrics: (state, action: PayloadAction<CalculatedMetrics>) => {
      state.metricsByDomain[action.payload.domainId] = action.payload;
    },
    clearMetricsForDomain: (state, action: PayloadAction<string>) => {
      delete state.metricsByDomain[action.payload];
    },
    clearAllMetrics: (state) => {
      state.metricsByDomain = {};
    },
  },
});

export const { setCalculatedMetrics, clearMetricsForDomain, clearAllMetrics } = metricsSlice.actions;
export default metricsSlice.reducer;
